import * as React from 'react';
/**
 *
 * Original name: comment
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A366
 *
 */
export const CommentPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 62", fill: "none", ...props },
    React.createElement("path", { d: "M50 11.625H14a6.107 6.107 0 0 0-4.24 1.704A5.729 5.729 0 0 0 8 17.437v23.25a5.729 5.729 0 0 0 1.76 4.109A6.107 6.107 0 0 0 14 46.5h2v9.15l16.531-9.15H50a6.107 6.107 0 0 0 4.24-1.704A5.73 5.73 0 0 0 56 40.688v-23.25a5.73 5.73 0 0 0-1.76-4.109A6.107 6.107 0 0 0 50 11.625Zm2 29.063c0 .513-.21 1.006-.586 1.37a2.033 2.033 0 0 1-1.414.567H31.469L20 48.975v-6.35h-6a2.03 2.03 0 0 1-1.414-.568 1.907 1.907 0 0 1-.586-1.37v-23.25c0-.513.21-1.006.586-1.37A2.033 2.033 0 0 1 14 15.5h36c.53 0 1.04.204 1.414.567.375.364.586.857.586 1.37v23.25Z", fill: "currentColor" }),
    React.createElement("path", { d: "M41 23.25H23v3.875h18V23.25ZM36 31H23v3.875h13V31Z", fill: "currentColor" })));
